import { render, staticRenderFns } from "./withData.vue?vue&type=template&id=8f78f3a0&"
import script from "./withData.vue?vue&type=script&lang=js&"
export * from "./withData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports